import { useState, useRef, forwardRef } from "react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Shuffle } from "lucide-react";

interface RemixButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const RemixButton = forwardRef<HTMLButtonElement, RemixButtonProps>(
  ({ onClick, disabled }, ref) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const handleMouseEnter = () => {
      timeoutRef.current = setTimeout(() => {
        setShowTooltip(true);
      }, 1000);
    };

    const handleMouseLeave = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      setShowTooltip(false);
    };

    return (
      <TooltipProvider>
        <Tooltip open={showTooltip}>
          <TooltipTrigger asChild>
            <Button
              ref={ref}
              variant="outline"
              size="sm"
              className="h-8 gap-1.5 text-xs"
              onClick={(e) => {
                e.stopPropagation();
                onClick();
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              disabled={disabled}
            >
              <Shuffle className="h-3.5 w-3.5" />
              Remix
            </Button>
          </TooltipTrigger>
          <TooltipContent side="top" className="max-w-[200px] text-center">
            <p>Remix this prompt to make it your own!</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
);

RemixButton.displayName = "RemixButton";
